/* eslint-disable no-console */

import { DriverI, LogFn } from '../types';

/**
 * ConsoleDriverConfig
 *
 * Config shape for the ConsoleDriver type
 */
export type ConsoleDriverConfig = {
    type: 'console';
    prefix?: string;
};

export const ConsoleDriver = ({
    prefix = 'Logger',
}: ConsoleDriverConfig): DriverI => {
    /**
     * debug
     *
     * Sends a debug level message to the Console
     */
    const debug: LogFn = (...args) => {
        console.debug(`${prefix}::debug`, ...args);
    };

    /**
     * error
     *
     * Sends a error level message to the Console
     */
    const error: LogFn = (...args) => {
        console.error(`${prefix}::error`, ...args);
    };

    /**
     * info
     *
     * Sends a info level message to the Console
     */
    const info: LogFn = (...args) => {
        console.info(`${prefix}::info`, ...args);
    };

    /**
     * log
     *
     * Sends a log level message to the Console
     */
    const log: LogFn = (...args) => {
        console.log(`${prefix}::log`, ...args);
    };

    /**
     * warn
     *
     * Sends a warn level message to the Console
     */
    const warn: LogFn = (...args) => {
        console.warn(`${prefix}::warn`, ...args);
    };

    return {
        debug,
        error,
        info,
        log,
        warn,
    };
};
